import ApiURL from "../controllers/Api";

export const apiUrl = (path) => {
  const base = ApiURL.endsWith("/") ? ApiURL : `${ApiURL}/`;
  const cleanPath = String(path || "").replace(/^\/+/, "");
  return `${base}${cleanPath}`;
};

export const readApiResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  const rawText = await response.text();

  if (!contentType.includes("application/json")) {
    const preview = rawText.trim().slice(0, 180);
    throw new Error(
      preview.startsWith("<")
        ? "API returned HTML instead of JSON. Check the endpoint URL on the deployed server."
        : preview || `API returned ${response.status} ${response.statusText}`
    );
  }

  let body;
  try {
    body = rawText ? JSON.parse(rawText) : {};
  } catch {
    throw new Error("API returned invalid JSON.");
  }

  if (!response.ok || body.success === false) {
    throw new Error(body.message || `Request failed with status ${response.status}`);
  }

  return body;
};

export const postJson = async (path, payload) => {
  const response = await fetch(apiUrl(path), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  return readApiResponse(response);
};
